import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const bannerRegularRolesRBAC = {
  pageID: '2233aadd35b31123b5497cd6331d7b71',
  elementID: {
    ViewPage: 'a887fbb5f52c71e02e6219b43170435f',
    ButtonCreateBanner: '09e960bd3b4d141e2b6e2f2fa84c692f',
    ButtonEditBanner: 'c16a76fcfcb57504bf81662ff7923625',
    UpdateBannerPosition: '2e77f7a0bcee8c50c67b2b5e0449b3fa',
    ToggleBannerStatus: '200f12345fed7b7831d94dadaca39ff9',
  },
} as const

export const useRBACBannerRegularPage = createUseRBAC(bannerRegularRolesRBAC.elementID)

export type UseRBACBannerRegularPageType = ReturnType<typeof useRBACBannerRegularPage>
